<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {}
  },
  created() {
    document.title = '领舆数智CRM';
  }
};
</script>

<style></style>
